import { useState } from "react";
import { Box, IconButton, Tooltip } from "@mui/material";
import Accordion from "@mui/material/Accordion";
import AccordionDetails from "@mui/material/AccordionDetails";
import AccordionSummary from "@mui/material/AccordionSummary";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { CodeBlock } from "react-code-blocks";
import "./CardInfoContent.scss";

interface BodyCodeViewProps {
  code: string;
}

export const BodyCodeView = ({ code }: BodyCodeViewProps) => {
  const [tooltipText, setTooltipText] = useState("Copy");

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(code);
      setTooltipText("Copied!");
      setTimeout(() => setTooltipText("Copy"), 3000);
    } catch (error) {
      console.error("Failed to copy code: ", error);
    }
  };

  return (
    <div>
      <Accordion defaultExpanded className="accordian-content">
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          sx={{ m: 0 }}
          className="accordian-header"
          aria-controls="body-code-content"
        >
          Body
        </AccordionSummary>
        <AccordionDetails className="accordian-info">
          <Box className="relative">
            <Tooltip title={tooltipText} placement="top" arrow>
              <IconButton
                aria-label="copy code"
                size="small"
                onClick={handleCopy}
                className="absolute! top-3 right-6 z-10 text-(--desaturateddarkblue) hover:text-(--darkblue)"
              >
                <i className="ac_icons">ac_copy</i>
              </IconButton>
            </Tooltip>
            <Box className="rounded-xl overflow-auto max-h-[350px] border border-(--lightishgray) [&>div]:rounded-xl [&_code]:!text-[14px] [&_pre]:!text-[14px] [&_span]:!text-[14px]">
              <CodeBlock
                text={code}
                language="json"
                showLineNumbers={true}
                customStyle={{
                  fontSize: "var(--font-size-14)",
                }}
                theme={{
                  lineNumberColor: "var(--desaturatedblue)",
                  lineNumberBgColor: "transparent",
                  backgroundColor: "var(--darkbluecustom)",
                  textColor: "var(--black)",
                  substringColor: "var(--vividblue)",
                  keywordColor: "var(--vividblue)",
                  attributeColor: "var(--darkblue)",
                  selectorAttributeColor: "var(--vividblue)",
                  docTagColor: "var(--vividblue)",
                  nameColor: "var(--darkblue)",
                  builtInColor: "var(--vividblue)",
                  literalColor: "var(--moderatecyan)",
                  bulletColor: "var(--desaturateddarkblue)",
                  codeColor: "var(--black)",
                  additionColor: "var(--darklimegreen)",
                  regexpColor: "var(--moderatecyan)",
                  symbolColor: "var(--vividblue)",
                  variableColor: "var(--vividblue)",
                  templateVariableColor: "var(--vividblue)",
                  linkColor: "var(--vividblue)",
                  selectorClassColor: "var(--vividblue)",
                  typeColor: "var(--vividblue)",
                  stringColor: "var(--moderatevioletcustom)",
                  selectorIdColor: "var(--vividblue)",
                  quoteColor: "var(--desaturatedblue)",
                  templateTagColor: "var(--vividblue)",
                  deletionColor: "var(--vividred)",
                  titleColor: "var(--darkblue)",
                  sectionColor: "var(--darkblue)",
                  commentColor: "var(--desaturatedblue)",
                  metaKeywordColor: "var(--vividblue)",
                  metaColor: "var(--vividblue)",
                  functionColor: "var(--vividblue)",
                  numberColor: "var(--vividblue)",
                }}
              />
            </Box>
          </Box>
        </AccordionDetails>
      </Accordion>
    </div>
  );
};
